export default __webpack_public_path__ + "static/media/earlySubscriberAndroid_1.03dc49da.png";